import { request } from "@/utils/request";

// 获取商品详情
export const productDet = (data) => {
  return request({
    url: "/product/mall/queryProductInfoById",
    method: "GET",
    data: data,
  });
};

// 添加浏览历史
export const browseHistoryAdd = (data) => {
  return request({
    url: "/product/mall/browseHistory/add",
    method: "POST",
    data,
  });
};

// 游客获取商品详情
export const productDetByVisitor = (data) => {
  return request({
    url: "/product/public/productDetByVisitor",
    method: "GET",
    data: data,
  });
};
// 商品详情(非站点客户)
export const productDetByNoClient = (data) => {
  return request({
    url: "/product/mall/productDetByNoClient",
    method: "GET",
    data: data,
  });
};

// 获取商品优惠信息
export const getDiscountByProductId = (data) => {
  return request({
    url: "/order/public/getDiscountByProductId",
    method: "GET",
    data: data,
  });
};

// 领取商品优惠券
export const collectCoupon = (params, companyCode) => {
  return request({
    url: `/order/public/collectCoupon?couponId=${params}&companyCode=${companyCode}`,
    method: "GET",
  });
};

// 获取发货信息
export const getDeliveryTimeByProduct = (data) => {
  return request({
    url: "/product/mall/getDeliveryTimeByProduct",
    method: "GET",
    data: data,
  });
};

// 添加购物车
export const addCart = (data) => {
  return request({
    url: "/product/mall/addBuyerCart",
    method: "POST",
    data: data,
  });
};

// 获取商品的有效期
export const productExpireDate = (data) => {
  return request({
    url: "/product/public/productExpireDate",
    method: "POST",
    data: data,
  });
};

// 立即购买获取证照权限信息
export const isSell = (data) => {
  return request({
    url: "/user/v2/public/isSell",
    method: "POST",
    data: data,
  });
};

// 接受价格
export const acceptDemandMain = (params) => {
  return request({
    url: "/order/mall/acceptDemandMain",
    method: "POST",
    data: params,
  });
};

// 不接受价格
export const rejectDemandMain = (params) => {
  return request({
    url: "/order/mall/rejectDemandMain",
    method: "POST",
    data: params,
  });
};

// 猜你喜欢
export const queryPcProductInfoByPageAndPublic = (params) => {
  return request({
    url: "/product/public/queryPcProductInfoByPageAndPublic",
    method: "POST",
    data: params,
  });
};

// 获取商品优惠信息
export const getDiscountList = (params) => {
  return request({
    url: "/order/public/getDiscountList",
    method: "POST",
    data: params,
  });
};

// 加入常购清单
export const addPurchaseList = (params) => {
  return request({
    url: "/product/mall/addFrequentPurchase",
    method: "POST",
    data: params,
  });
};

// 查询详情里的是否关注
export const getIsFavorite = (params) => {
  return request({
    url: "/product/mall/selectIsCollected",
    method: "POST",
    data: params,
  });
};

// 加入关注
export const addFavoriteList = (params) => {
  return request({
    url: "/product/mall/insertProductCollection",
    method: "POST",
    data: params,
  });
};
// 取消关注
export const removeFavorite = (params) => {
  return request({
    url: "/product/mall/deleteProductCollection",
    method: "POST",
    data: params,
  });
};
// 获得关注列表
export const getFavoriteList = (params) => {
  return request({
    url: "/product/mall/queryCollectedProductList",
    method: "POST",
    data: params,
  });
};

// 批量删除关注
export const deleteCollectionByProductIds = (params) => {
  return request({
    url: "/product/mall/deleteCollectionByProductIds",
    method: "POST",
    data: params,
  });
};

// 批量获取首营状态
export const checkIsSell = (params) => {
  return request({
    url: "/user/mall/checkIsSell",
    method: "POST",
    data: params,
  });
};
